import { render, staticRenderFns } from "./club-view-page.vue?vue&type=template&id=3286c807&"
import script from "./club-view-page.vue?vue&type=script&lang=js&"
export * from "./club-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports